import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";

export async function getUserField(userId, fieldName) {
  try {
    const userDocRef = doc(db, "users", userId);
    const userDocSnap = await getDoc(userDocRef);
    if (userDocSnap.exists()) {
      return userDocSnap.data()[fieldName] || "";
    }
    return "";
  } catch (error) {
    console.error(`Error fetching user ${fieldName}:`, error);
    return "";
  }
}
